import { render } from "./EditJobVacancy.vue?vue&type=template&id=01351da0&scoped=true"
import script from "./EditJobVacancy.vue?vue&type=script&lang=js"
export * from "./EditJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=01351da0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01351da0"]])

export default __exports__